import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {DiagramDto, DrawIoDto} from "../../dto/drawio.dto";

@Component({
    selector: 'mvs-drawio',
    templateUrl: './mvs-drawio.component.html',
    standalone: false
})
export class DrawIoComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

    @ViewChild('iframe') iframe!: ElementRef<HTMLIFrameElement>;
    @Input() diagramXML: DiagramDto
    @Output() drawIOData: EventEmitter<DrawIoDto> = new EventEmitter();

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    drawIoUrl: SafeResourceUrl;
    private messageListener = this.onMessage.bind(this);
    iframeReady: boolean = false;

    constructor(private sanitizer: DomSanitizer) {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.drawIoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            'https://embed.diagrams.net/?embed=1&proto=json&spin=1&ui=light&libraries=0'
        );
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.loadDiagram();
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }
        if (changes['diagramXML']) {
            this.refreshComponent()
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {
        window.removeEventListener('message', this.messageListener);
    }

    ngAfterViewInit(): void {
        // Listen for iframe messages
        window.addEventListener('message', this.messageListener);
    }

    onMessage(event: MessageEvent) {
        if (event.origin !== 'https://embed.diagrams.net') return;

        let msg: any;
        try {
            msg = JSON.parse(event.data);
        } catch {
            return;
        }

        switch (msg.event) {
            case 'init':
                this.iframeReady = true;
                this.loadDiagram();
                break;

            case 'save':
                this.iframe.nativeElement.contentWindow?.postMessage(
                    JSON.stringify({action: 'export', format: 'xmlpng', spinKey: 'saving'}), '*'
                );
                break;

            case 'export':
                const enriched = {
                    ...msg,
                    delta: this.diagramXML?.delta ?? null,
                };
                this.drawIOData.emit(enriched);
                break;
        }
    }

    loadDiagram(): void {
        this.iframe.nativeElement.contentWindow?.postMessage(JSON.stringify(
            {action: 'load', xml: this.diagramXML?.xml ?? ''}), '*');
    }
}
